import React from "react";
import { CalendarClock, CheckCircle2, Circle } from "lucide-react";

import { data, dataHora, reais } from "../comum/formato";

function Linha({ rotulo, valor }) {
  return (
    <div className="flex justify-between gap-3 py-1.5 border-b last:border-0 text-sm">
      <span className="text-muted-foreground">{rotulo}</span>
      <span className="font-medium text-right">{valor}</span>
    </div>
  );
}

// Como o cupom funciona e a linha do tempo dele (criado → válido → usos → fim).
export default function RegrasCupom({ cupom: c, tempo }) {
  if (!c.existe) {
    return <section className="rounded-xl border bg-card p-4 sm:p-5 text-sm text-muted-foreground">Este cupom foi excluído do cadastro. Os pedidos que usaram o código continuam no relatório.</section>;
  }
  const eventos = [
    { rotulo: "Criado", quando: tempo.criado_em, hora: true },
    { rotulo: "Válido a partir de", quando: tempo.valido_de },
    { rotulo: "Primeiro uso", quando: tempo.primeiro_uso, hora: true },
    { rotulo: "Último uso", quando: tempo.ultimo_uso, hora: true },
    { rotulo: "Válido até", quando: tempo.valido_ate },
  ].filter((e) => e.quando).sort((a, b) => String(a.quando).localeCompare(String(b.quando)));
  const hoje = new Date().toLocaleDateString("sv-SE");
  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="regras-cupom">
        <h3 className="font-semibold mb-2">Como o cupom funciona</h3>
        <Linha rotulo="Desconto" valor={`${c.valor_rotulo}${c.tipo === "percentage" && c.desconto_maximo ? ` (até ${reais(c.desconto_maximo)})` : ""}`} />
        <Linha rotulo="Pedido mínimo" valor={c.pedido_minimo ? reais(c.pedido_minimo) : "Sem mínimo"} />
        <Linha rotulo="Validade" valor={c.valido_de || c.valido_ate ? `${c.valido_de ? data(c.valido_de) : "desde a criação"} até ${c.valido_ate ? data(c.valido_ate) : "sem fim"}` : "Sem prazo"} />
        <Linha rotulo="Dias da semana" valor={c.dias_semana?.length ? c.dias_semana.join(", ") : "Todos"} />
        <Linha rotulo="Horário" valor={c.horario || "O dia todo"} />
        <Linha rotulo="Usos" valor={`${c.usos_total}${c.limite_total ? ` de ${c.limite_total}` : " (sem limite)"}`} />
        <Linha rotulo="Por cliente" valor={c.limite_por_cliente ? `até ${c.limite_por_cliente}x` : "Sem limite"} />
        <Linha rotulo="Quem pode usar" valor={c.reservado_para ? `Só ${c.reservado_para}` : c.primeiro_pedido ? "Só no primeiro pedido" : "Qualquer cliente"} />
        <Linha rotulo="Vale no frete" valor={c.vale_no_frete ? "Sim" : "Não"} />
        <Linha rotulo="Origem" valor={c.categoria_rotulo} />
      </section>
      <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="linha-do-tempo">
        <h3 className="font-semibold mb-3 flex items-center gap-2"><CalendarClock className="w-4 h-4 text-sky-500" /> Linha do tempo</h3>
        <ol className="space-y-3">
          {eventos.map((e) => {
            const passou = String(e.quando).slice(0, 10) <= hoje;
            return (
              <li key={e.rotulo} className="flex items-center gap-3">
                {passou ? <CheckCircle2 className="w-4 h-4 text-sky-500 shrink-0" /> : <Circle className="w-4 h-4 text-muted-foreground shrink-0" />}
                <span className="text-sm flex-1">{e.rotulo}</span>
                <span className="text-sm font-semibold tabular-nums">{e.hora ? dataHora(e.quando) : data(e.quando)}</span>
              </li>
            );
          })}
        </ol>
        {!tempo.primeiro_uso && <p className="text-xs text-muted-foreground mt-3">Ainda não foi usado.</p>}
      </section>
    </div>
  );
}
